export default __webpack_public_path__ + "static/media/Eye.7151cf5a.svg";